import Input from "ant-design-vue/lib/input"; // 加载 JS
import "ant-design-vue/lib/input/style/css"; // 加载 CSS
import Button from "ant-design-vue/lib/button"; // 加载 JS
import "ant-design-vue/lib/button/style/css"; // 加载 CSS
import debounce from 'lodash/debounce';
import Vue from "vue";
import api from "../../services/api";
Vue.use(Button).use(Input);
const inputMixin = {
  props: {
    field: {},
    fieldValue: "",
    smsType: "",
    fieldResult: {},
    checkFlag: false,
    isPassword: false,

    fieldStyle: {
      type: String,
      default: "style1"
    }
  },
  data() {
    return {
      sendCodeData: {
        timing: null,
        tiem: 60
      },
      phone:'',
      country:'',
      onlyCountry: [],


      isShowBussiness:false,
      isSelected:false,
      businessList:[],
      fieldObj: {},
      inputValue: this.fieldValue || ""
    };
  },
  watch: {
    checkFlag() {
      this.fieldObj.dirty = true;

      // 手机号需要验证码时 没有输入验证码 提示请输入验证码
      if (this.fieldObj.isSendSms == 1 && !this.fieldObj.verificationCode) {
        this.fieldObj.verificationCodeDirty = true;
      }
      if (this.fieldObj.isSendSms == 1) {
        if (this.fieldObj.fieldName === 'mobile' && this.field.isCallingCodeOpen == 1) {
          this.$emit("update:fieldValue", {
            VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
            fieldName: this.fieldObj.fieldName,
            value: this.phone + this.inputValue,
            checkCode: this.fieldObj.verificationCode,
          });
        }else {
          this.$emit("update:fieldValue", {
            VerifyFail:
            (this.fieldObj.dirty && this.fieldObj.invalid) ||
            (this.fieldObj.verificationCodeDirty &&
              this.fieldObj.verificationCodeError),
            fieldName: this.fieldObj.fieldName,
            checkCode: this.fieldObj.verificationCode,
            value: this.inputValue
          });
        }
      } else if (this.fieldObj.fieldName === 'enterprise') {
        this.$emit("update:fieldValue", {
          VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
          fieldName: this.fieldObj.fieldName,
          value: this.inputValue,
          otherValue: this.field.otherV,
          thirdValue: this.field.thirdValue
        });
      } else if (this.fieldObj.fieldName === 'mobile' && this.field.isCallingCodeOpen == 1) {
        this.$emit("update:fieldValue", {
          VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
          fieldName: this.fieldObj.fieldName,
          value: this.inputValue ? this.phone + this.inputValue : this.inputValue
        });
      } else {
        this.$emit("update:fieldValue", {
          VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
          fieldName: this.fieldObj.fieldName,
          value: this.inputValue
        });
      }

      this.$emit("update:fieldResult", this.fieldObj);
    }
  },
  mounted(){
    var self = this;
    if(this.field.fieldName == 'enterprise') {
      document.addEventListener('click', (e) => {
        self.isShowBussiness = false;
        e;
        if (self.field.submitBusiness == 1 && !self.isSelected) {//必选
          if (self.fieldObj.dirty) {
            self.fieldObj.setValue('');
            self.inputValue = '';
          }
        }
      })
    }
    if(this.field.fieldName == 'mobile' && this.field.isCallingCodeOpen == 1) {
      //开启国家码
      if(this.field.showCallingCode && this.field.showCallingCode.length > 0){
        this.onlyCountry = this.field.showCallingCode.map(r => {
          if(r.callingCode == this.field.defaultCallingCode){
            this.country = r.callingCode;
            this.phone = r.areaCode
          }
          return r.callingCode;
        })
        if(this.field.callingCodeLookupCountry){
          this.country = this.field.callingCodeLookupCountry;
          this.phone = this.field.callingCodeLookupPhone;
        }
      }
    }
  },
  created() {
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = "请回答";
    }
    this.fieldObj = new window.$sk.Text(this.field);
    // 不是读写权限禁用
    this.fieldObj.disabled = this.field.permissionType && this.field.permissionType != 'write';
    if (this.fieldValue) {
      if (this.fieldObj.isSensitive == 1) {
        this.fieldObj.initValue(this.inputValue);
      } else {
        this.fieldObj.setValue(this.inputValue);
      }
    }
    this.$emit("update:fieldResult", this.fieldObj);
  },
  methods: {
    changePhone(data){
      if(data){
        this.phone = data.dialCode;
        this.country = data.iso2;
      }
    },
    textChange() {
      // if(1== 1){

      if(this.field.openBusiness == 1 && this.field.fieldName == 'enterprise'){

        this.getBusinessList();
        this.field.otherV = '';
        this.field.thirdValue = 0;
        this.$emit("update:fieldValue", {
          VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
          fieldName: this.fieldObj.fieldName,
          value: this.inputValue,
          otherValue: ''
        });
      }
      this.fieldObj.setValue(this.inputValue);
      this.$emit("change",{
        displayType:this.fieldObj.displayType,
        value: this.inputValue,
        rulesInfo:this.field.rulesInfo,
        rulesCode:this.field.fieldName,
        sortBy:this.field.sortBy,
        code:this.phone
      });
      this.$emit("update:fieldValue", {
        otherValue: '',
        code: this.phone
      });
    },
    setBusiness(item){
      setTimeout(()=>{
        this.fieldObj.setValue(item.name);
        this.inputValue = item.name;
        this.isSelected = true;
        this.isShowBussiness = false;
        this.field.otherV = item.creditCode;
        this.field.thirdValue = 1;
        this.$emit("change",{
          displayType:this.fieldObj.displayType,
          value: this.inputValue,
          rulesInfo:this.field.rulesInfo,
          rulesCode:this.field.fieldName,
          sortBy:this.field.sortBy
        });
      },0)

    },
    stopPropagation(e,fieldName){
      if(fieldName == 'enterprise'){
        e.stopPropagation()
      }
    },
    blur(e){
      e;
      if(this.field.fieldName == 'enterprise'){
        self.isShowBussiness = false;
        if(this.field.submitBusiness == 1 && !this.isSelected){//必选
          if(this.fieldObj.dirty) {
            this.inputValue = '';
            this.fieldObj.setValue('');
            this.$emit("update:fieldValue", {
              VerifyFail: this.fieldObj.dirty && this.fieldObj.invalid,
              fieldName: this.fieldObj.fieldName,
              value: this.inputValue,
              otherValue: ''
            });
            // this.inputValue = '';
          }
        }
      }
    },
    smsChange() {
      this.fieldObj.setCode(this.fieldObj.verificationCode);
    },
    // 获取验证码
    sendCode() {
      if(this.field.isCallingCodeOpen) {
        this.fieldObj.areaCode = this.phone;
      }else{
        this.fieldObj.areaCode = '';
      }
      this.fieldObj.sendCode(this.smsType, { tenantId: this.field.tenantId });
    },
    getBusinessList:debounce(function () {
      this.businessList = [];
      this.isSelected = false;
      if(this.inputValue.length<1){
        return
      }
      api
        .serchBusiness({
          tenantId: window.$sk.template.get().common.tenantId,
          objMark: window.$sk.template.get().common.objMark || '123',
          objId: window.$sk.template.get().common.objId,
          type: window.$sk.template.get().common.type,
          globalUserId: window.$sk.template.get().user.globalUserId,
          keyword: this.inputValue
        })
        .subscribe(res => {
          if(res.result==0) {
            if(this.inputValue.length>1) {
              this.isShowBussiness = true;

              this.businessList = res.content.items.map((item) => {
                item.showName = item.name.replace((new RegExp(this.inputValue, 'gi')), `<span class="high-light">${this.inputValue}</span>`);
                return item;
              });
            }else{
              this.businessList = [];
            }
          }else {
            //接口返回异常时候不限制，可以随意输入不选择
            this.field.submitBusiness = 0;
            this.field.openBusiness = 0;
            // 显示错误信息
            if(res.result == 19988) {
              this.$refs.errorDesc.style.display = 'block';
              this.$refs.errorDesc.innerHTML = res.desc;
            }
          }

        });
    },500)

  }
};
export default inputMixin;